// Podtemat 5 - zadania zamkniete egzaminu osmoklasisty z dzialu VI (planimetria).

import * as RightTriangleAreas from "../../temat1_trojkaty/podtemat2_pole_trojkata_types/E8RightTriangleAreasPFClosedTask";
import * as CompositeTrapezoid from "../../temat2_czworokaty/podtemat3_trapezy_types/E8CompositeTrapezoidPerimeterClosedTask";
import * as EquilateralTrianglePF from "../../temat1_trojkaty/podtemat5_trojkat_rownoboczny_types/E8EquilateralTrianglePFClosedTask";
import * as QuadrilateralAngles from "../../temat2_czworokaty/podtemat4_katy_czworokatow_types/E8QuadrilateralAnglesClosedTask";
import * as PentagonSquareArea from "../../temat2_czworokaty/podtemat1_prostokaty_kwadraty_types/E8PentagonSquareAreaClosedTask";

export const registry = {
  E8RightTriangleAreasPFClosedTask: RightTriangleAreas,
  E8CompositeTrapezoidPerimeterClosedTask: CompositeTrapezoid,
  E8EquilateralTrianglePFClosedTask: EquilateralTrianglePF,
  E8QuadrilateralAnglesClosedTask: QuadrilateralAngles,
  E8PentagonSquareAreaClosedTask: PentagonSquareArea,
};

export function generateTasks(options = {}) {
  return [
    RightTriangleAreas.generateTask(options),
    EquilateralTrianglePF.generateTask(options),
    QuadrilateralAngles.generateTask(options),
    PentagonSquareArea.generateTask(options),
    CompositeTrapezoid.generateTask(options),
  ];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 closed task type in planimetria: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}
